import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", { class: "flex-0" }, "Bitte hier Unterschreiben", -1)
const _hoisted_2 = { class: "flex-fill d-flex" }
const _hoisted_3 = { id: "signature_content" }
const _hoisted_4 = { class: "d-flex flex-row mt-2 mt-lg-3 flex-0 btn-group mb-2" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Signature = _resolveComponent("Signature")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["wrapper d-flex flex-column align-items-stretch", {'pb-0':!_ctx.paddingBottom}])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Signature, {
          onUpdate: _ctx.updateSignature,
          ref: "sign"
        }, null, 8, ["onUpdate"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: "btn bg-light btn-lg",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveSignatureAsImage && _ctx.saveSignatureAsImage(...args))),
        disabled: _ctx.signatureData.length <= 0
      }, "Bild Sichern", 8, _hoisted_5),
      _createElementVNode("button", {
        class: "btn bg-light btn-lg",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveSignatureAsData && _ctx.saveSignatureAsData(...args))),
        disabled: _ctx.signatureData.length <= 0
      }, "Data Sichern", 8, _hoisted_6),
      _createElementVNode("button", {
        class: "btn bg-danger btn-lg",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resetSignature && _ctx.resetSignature(...args))),
        disabled: _ctx.signatureData.length <= 0
      }, "Reset", 8, _hoisted_7)
    ])
  ], 2))
}